__turbopack_context__.v({
  "downloadLink": "CommunityDownloads-module-scss-module__Wz-gYW__downloadLink",
  "downloadsScrollContainer": "CommunityDownloads-module-scss-module__Wz-gYW__downloadsScrollContainer",
  "downloadsTable": "CommunityDownloads-module-scss-module__Wz-gYW__downloadsTable",
});
